var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGr1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 200,
    viewBox: "0 0 335 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_194_166",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 200
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23857 2.23858 0 5 0H330C332.761 0 335 2.23858 335 5V195C335 197.761 332.761 200 330 200H5C2.23857 200 0 197.761 0 195V5Z",
    fill: "url(#paint0_linear_194_166)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_194_166)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_194_166)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23857 2.23858 0 5 0H330C332.761 0 335 2.23858 335 5V195C335 197.761 332.761 200 330 200H5C2.23857 200 0 197.761 0 195V5Z",
    fill: "url(#paint1_linear_194_166)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_194_166",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 200
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23857 2.23858 0 5 0H330C332.761 0 335 2.23858 335 5V195C335 197.761 332.761 200 330 200H5C2.23857 200 0 197.761 0 195V5Z",
    fill: "url(#paint2_linear_194_166)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_194_166)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pathAnimate",
    d: "M346 209V142.016C305.5 141.114 319 141.114 285 141.114C207.801 141.114 130.5 63.5 49.5 55.3C48 55.3 11.254 55 -11 55V209H346Z",
    fill: "url(#paint3_linear_194_166)",
    stroke: "url(#paint4_linear_194_166)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 62H49V166H50V62Z",
    fill: "url(#paint5_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68 66H67V166H68V66Z",
    fill: "url(#paint6_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M88 75H87V166H88V75Z",
    fill: "url(#paint7_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108 87H107V166H108V87Z",
    fill: "url(#paint8_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M128 98H127V166H128V98Z",
    fill: "url(#paint9_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148 108H147V166H148V108Z",
    fill: "url(#paint10_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168 118H167V166H168V118Z",
    fill: "url(#paint11_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M188 125H187V166H188V125Z",
    fill: "url(#paint12_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M208 130H207V166H208V130Z",
    fill: "url(#paint13_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M228 135H227V166H228V135Z",
    fill: "url(#paint14_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M248 139H247V166H248V139Z",
    fill: "url(#paint15_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M268 141H267V166H268V141Z",
    fill: "url(#paint16_linear_194_166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 146H285V166H286V146Z",
    fill: "url(#paint17_linear_194_166)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "circle1",
    x: 46.5,
    y: 52.5,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#B43A3A",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "circle2",
    x: 280.5,
    y: 136.5,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#16E744",
    stroke: "white",
    strokeWidth: 3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_194_166",
    x: 0,
    y: 0,
    width: 335,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_194_166"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_166",
    x1: 335,
    y1: -0.00000481285,
    x2: 10.2546,
    y2: 237.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF37FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425831,
    stopColor: "#333BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_194_166",
    x1: 335,
    y1: -0.00000481285,
    x2: 10.2546,
    y2: 237.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF37FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425831,
    stopColor: "#333BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_194_166",
    x1: 335,
    y1: -0.00000481285,
    x2: 10.2546,
    y2: 237.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF37FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425831,
    stopColor: "#333BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_194_166",
    x1: 173.078,
    y1: -157.285,
    x2: 173.078,
    y2: 156.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#957FFB",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_194_166",
    x1: 49.5,
    y1: 39.5,
    x2: 274.278,
    y2: 158.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477465,
    stopColor: "#E2DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17DD44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_194_166",
    x1: 49.0108,
    y1: 166.185,
    x2: 49.0108,
    y2: 63.4394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_194_166",
    x1: 67.0108,
    y1: 166.178,
    x2: 67.0108,
    y2: 67.3841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_194_166",
    x1: 87.0108,
    y1: 166.162,
    x2: 87.0108,
    y2: 76.2595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_194_166",
    x1: 107.011,
    y1: 166.141,
    x2: 107.011,
    y2: 88.0934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_194_166",
    x1: 127.011,
    y1: 166.121,
    x2: 127.011,
    y2: 98.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_194_166",
    x1: 147.011,
    y1: 166.103,
    x2: 147.011,
    y2: 108.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_194_166",
    x1: 167.011,
    y1: 166.085,
    x2: 167.011,
    y2: 118.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_194_166",
    x1: 187.011,
    y1: 166.073,
    x2: 187.011,
    y2: 125.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_194_166",
    x1: 207.011,
    y1: 166.064,
    x2: 207.011,
    y2: 130.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_194_166",
    x1: 227.011,
    y1: 166.055,
    x2: 227.011,
    y2: 135.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_194_166",
    x1: 247.011,
    y1: 166.048,
    x2: 247.011,
    y2: 139.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_194_166",
    x1: 267.011,
    y1: 166.045,
    x2: 267.011,
    y2: 141.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_194_166",
    x1: 285.011,
    y1: 166.036,
    x2: 285.011,
    y2: 146.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr1);
export default __webpack_public_path__ + "static/media/gr1.ca6887a289f53082ff1d94b7fc2d99b8.svg";
export { ForwardRef as ReactComponent };